import { getImageDataFromWpResponse } from 'utils/transformHelpers';
import type { ArticleAttribution, ImageObj, WpArticleAttribution } from 'types';

export const EMPTY_ARTICLE_ATTRIBUTION: ArticleAttribution = {
  author: '',
};

export function hasArticleAttribution(
  attribution: ArticleAttribution
): boolean {
  return Boolean(attribution.author || attribution.avatar);
}

export function getArticleAttributionFromWpResponse(
  attribution?: WpArticleAttribution | null
): ArticleAttribution {
  if (!attribution?.author && !attribution?.avatar) {
    return EMPTY_ARTICLE_ATTRIBUTION;
  }

  const avatar = attribution.avatar
    ? (
        getImageDataFromWpResponse({
          image: attribution.avatar,
        }) as { image?: ImageObj }
      ).image
    : undefined;

  return {
    author: attribution.author || '',
    ...(avatar ? { avatar } : {}),
  };
}
